/**
 * 비밀번호 재설정 링크의 쿼리에서 토큰 추출.
 * - `token`, `resetToken` 모두 허용 (메일 링크는 보통 `?token=`)
 * - trim + decodeURIComponent
 */
export function readPasswordResetTokenFromSearchParams(searchParams: URLSearchParams): string | null {
	const raw = searchParams.get('token') ?? searchParams.get('resetToken');
	if (raw == null) return null;
	const trimmed = raw.trim();
	if (!trimmed) return null;
	try {
		return decodeURIComponent(trimmed);
	} catch {
		return trimmed;
	}
}
